import React from "react";
import Spinner from "./Spinner";

function Button({
    children,
    onClick,
    type = "button",
    className = "",
    style = {},
    variant = "primary",
    startIcon,
    endIcon,
    isLoading = false,
    disabled = false,
    form,
    ...rest
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || isLoading}
            style={style}
            form={form}
            className={`flex rounded-3xl px-4 py-2 !focus:outline-none !focus:ring-2 !focus:ring-opacity-75 items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed ${
                variant === "primary"
                    ? "bg-black text-white"
                    : variant === "secondary"
                    ? "bg-gray-500 text-white hover:bg-[#e5e7eb]"
                    : variant === "danger"
                    ? "bg-red-500 text-white hover:bg-red-600 focus:ring-red-400"
                    : variant === "success"
                    ? "bg-green-500 text-white hover:bg-green-600 focus:ring-green-400"
                    : variant === "text"
                    ? "bg-[#F5F5F5] text-black hover:text-gray-600 focus:outline-none"
                    : variant === 'primary-light'
                    ? "bg-primary-light text-black hover:bg-gray-2  00 focus:outline-none"
                    : ""
            } ${className}`}
            {...rest}
        >
            {isLoading ? (
                <>
                    <span>{children}</span>
                    <Spinner />
                </>
            ) : (
                <>
                    {startIcon && <span className="mr-2">{startIcon}</span>}
                    {children}
                    {endIcon && <span className="ml-2">{endIcon}</span>}
                </>
            )}
        </button>
    );
}

export default Button;
